import React from "react";
import Tooltip from "./Tooltip";
import { TooltipPosition } from "./Tooltip/Tooltip";

const CellWithTooltip = ({
  value,
  tooltipOptions = {
    content: "",
    position: "top",
  },
}: {
  value: any;
  tooltipOptions?: {
    content: string;
    position?: TooltipPosition;
  };
}) => {
  return (
    <Tooltip
      content={tooltipOptions.content || value}
      position={tooltipOptions.position}
    >
      {value}
    </Tooltip>
  );
};

export default CellWithTooltip;
